import UserService from '../../services/user.service';

const state = {
    isAuthenticated: false,
    user: null,
    keycloak: null,
};

const mutations = {
    login(state, user) {
        console.log("Login " + user.username);
        state.isAuthenticated = true;
        user.password = null;
        state.user = user;
        if (this.keycloak !== null) {
            localStorage.setItem('token', state.keycloak.token);
            localStorage.setItem('idToken', state.keycloak.idToken);
            localStorage.setItem('refreshToken', state.keycloak.refreshToken);
        } else {
            localStorage.setItem('token', user.token);
        }
    },
    logout(state) {
        localStorage.removeItem('token');
        state.isAuthenticated = false;
        state.user = null;
    },
    setKeycloak(state, keycloak) {
        state.keycloak = keycloak;
        state.isAuthenticated = keycloak.authenticated;
        localStorage.setItem('token', state.keycloak.token);
        localStorage.setItem('idToken', keycloak.idToken);
        localStorage.setItem('refreshToken', keycloak.refreshToken);
    },
    setAuth(state, auth) {
        state.isAuthenticated = auth.isAuthenticated;
        state.user = {username: auth.username};
    }
};

const getters = {
    isAuthenticated: (state) => {
        if (state.keycloak !== null) {
            console.log('getKeycloak authenticated');
            return state.keycloak.authenticated;
        }

        return state.isAuthenticated;
    }
}

const actions = {
    setKeycloak(context, keycloak) {
        context.commit('setKeycloak', keycloak);
    },
    login(context, user) {
        return new Promise((resolve) => {
            UserService.login(user).then(() => {
                context.commit('login', user);
                context.dispatch('config/loadConfiguration', null, {root: true}).then(() => {
                    resolve();
                });
            }).catch(() => {
                context.dispatch('config/loadConfiguration', null, {root: true}).then(() => {
                    resolve();
                });
            });

        })
    },
    keycloakLogin(context, user) {
        return new Promise((resolve) => {
            UserService.keycloakLogin(user).then((r) => {
                console.log("KeycloakResponse: ", r);
                user['token'] = r.data.access_token;
                context.commit('login', user);
                context.dispatch('config/loadConfiguration', null, {root: true}).then(() => {
                    resolve();
                });
            }).catch(() => {
                context.dispatch('config/loadConfiguration', null, {root: true}).then(() => {
                    resolve();
                });
            });

        })
    },
    setLogin(context, user) {
        context.commit('login', user);
    },
    logout(context) {
        context.commit('logout');
        return UserService.logOut();
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
